import { useState, useEffect } from 'react';
import { collection, getDocs, collectionGroup } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import Layout from '../../components/ui/Layout';
import PageHeader from '../../components/ui/PageHeader';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { useAuth } from '../../context/AuthContext';
import { db, functions } from '../../firebase';

export default function Dashboard() {
  const { userProfile } = useAuth();
  const [counts, setCounts] = useState({ makes: '–', models: '–', parts: '–', pending: '–' });
  const [testResult, setTestResult] = useState(null);
  const [testLoading, setTestLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [makesSnap, modelsSnap, partsSnap, requestsSnap] = await Promise.all([
          getDocs(collection(db, 'makes')),
          getDocs(collectionGroup(db, 'models')),
          getDocs(collection(db, 'parts')),
          getDocs(collection(db, 'libraryRequests')),
        ]);
        const pendingCount = requestsSnap.docs.filter(d => d.data().status === 'pending').length;
        setCounts({ makes: makesSnap.size, models: modelsSnap.size, parts: partsSnap.size, pending: pendingCount });
      } catch (err) {
        console.error('Count fetch failed', err);
      }
    })();
  }, []);

  const testWhoAmI = async () => {
    setTestLoading(true); setTestResult(null);
    try {
      const fn = httpsCallable(functions, 'whoAmI');
      const result = await fn({});
      setTestResult({ ok: true, data: result.data });
    } catch (err) {
      setTestResult({ ok: false, message: err.message });
    }
    setTestLoading(false);
  };

  return (
    <Layout>
      <PageHeader title="Dashboard" subtitle={`Welcome back, ${userProfile?.name || userProfile?.email || ''}`} />
      <div style={{ padding: 28 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 28 }}>
          <Card><div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>Makes</div><div style={{ fontSize: 28, fontWeight: 400 }}>{counts.makes}</div></Card>
          <Card><div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>Models</div><div style={{ fontSize: 28, fontWeight: 400 }}>{counts.models}</div></Card>
          <Card><div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>Parts</div><div style={{ fontSize: 28, fontWeight: 400 }}>{counts.parts}</div></Card>
          <Card><div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>Pending review</div><div style={{ fontSize: 28, fontWeight: 400, color: 'var(--color-brand)' }}>{counts.pending}</div></Card>
        </div>

        <Card style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>Welcome to Agriware HQ</div>
          <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.6 }}>
            This is your internal hub for managing the Agriware machine library — makes, models, parts, and service schedules that Ops customers draw from.
          </div>
        </Card>

        <Card>
          <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 8 }}>Cross-project auth test (TEMPORARY)</div>
          <Button size="sm" loading={testLoading} onClick={testWhoAmI}>Test whoAmI</Button>
          {testResult?.ok && (
            <pre style={{ marginTop: 12, padding: 12, background: 'var(--color-bg-secondary)', borderRadius: 'var(--radius-md)', fontSize: 11, fontFamily: 'var(--font-mono)' }}>
              {JSON.stringify(testResult.data, null, 2)}
            </pre>
          )}
          {testResult && !testResult.ok && (
            <div style={{ marginTop: 12, padding: 10, background: 'var(--color-danger-light)', color: 'var(--color-danger)', borderRadius: 'var(--radius-md)', fontSize: 12 }}>
              {testResult.message}
            </div>
          )}
        </Card>
      </div>
    </Layout>
  );
}
